export enum ProdutoModeloEnum {
    A1 = 1,
    A1Description = 'A1',
    A3 = 2,
    A3Description = 'A3',
}
